import logoSrc from "./assets/artemulk-logo.png";

/**
 * Arte Mülk — backend admin paneli ile aynı logo (artemulk-logo.png).
 */
const ArtemulkLogo = ({
  className = "",
  whiteInDark = true,
  white = false,
}) => (
  <img
    src={logoSrc}
    alt="Arte Mülk Yönetimi"
    width={260}
    height={52}
    className={[
      className,
      white && "brightness-0 invert",
      !white && whiteInDark && "dark:brightness-0 dark:invert",
    ]
      .filter(Boolean)
      .join(" ")}
    style={{ objectFit: "contain", display: "block" }}
    decoding="async"
  />
);

export default ArtemulkLogo;
